// ============================================
// Poker Massage App - Main Application
// ============================================

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Admin Pages
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminEvents from './pages/admin/Events';
import AdminEventDetail from './pages/admin/EventDetail';
import AdminEventCreate from './pages/admin/EventCreate';
import AdminJoin from './pages/admin/AdminJoin';
import AdminSignups from './pages/admin/Signups';

// Therapist Pages
import TherapistLayout from './pages/therapist/TherapistLayout';
import TherapistHome from './pages/therapist/Home';
import TherapistJoin from './pages/therapist/Join';
import TherapistProfile from './pages/therapist/Profile';
import TherapistSession from './pages/therapist/Session';

// Player Pages
import PlayerLayout from './pages/player/PlayerLayout';
import PlayerBook from './pages/player/Book';
import PlayerStatus from './pages/player/Status';
import PlayerFeedback from './pages/player/Feedback';

// Common
import Landing from './pages/Landing';
import Login from './pages/Login';
import NotFound from './pages/NotFound';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Admin Join - standalone page (not within AdminLayout) */}
          <Route path="/admin/join" element={<AdminJoin />} />

          {/* Therapist Join - standalone page (not within TherapistLayout) */}
          <Route path="/t/join" element={<TherapistJoin />} />

          {/* Admin Routes - /admin */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="events/new" element={<AdminEventCreate />} />
            <Route path="events/:eventId/*" element={<AdminEventDetail />} />
            <Route path="signups" element={<AdminSignups />} />
          </Route>

          {/* Therapist Routes - /t */}
          <Route path="/t" element={<TherapistLayout />}>
            <Route index element={<TherapistHome />} />
            <Route path="profile" element={<TherapistProfile />} />
            <Route path="session/:sessionId" element={<TherapistSession />} />
          </Route>

          {/* Player Routes - /e/:eventId */}
          <Route path="/e/:eventId" element={<PlayerLayout />}>
            <Route index element={<PlayerBook />} />
            <Route path="status" element={<PlayerStatus />} />
            <Route path="feedback/:sessionId" element={<PlayerFeedback />} />
          </Route>

          {/* Landing Page */}
          <Route path="/" element={<Landing />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
